// src/Components/Footer.js
import React from "react";
import "./Footer.css"; // We'll create this file next

function Footer() {
  return (
    <section className="products-footer">
      <p>© 2025 RoboFication LLC. All Rights Reserved.</p>
      <p>
        <strong>Stay Connected With Us</strong>
      </p>
      <div className="social-links">
        <a
          href="https://www.linkedin.com/company/robofication"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
        <a
          href="https://x.com/robofication"
          target="_blank"
          rel="noopener noreferrer"
        >
          Twitter (X)
        </a>
        <a
          href="https://www.youtube.com/@RoboFication/videos"
          target="_blank"
          rel="noopener noreferrer"
        >
          YouTube
        </a>
      </div>
    </section>
  );
}

export default Footer;
